module.exports = __webpack_public_path__ + "img/dangerous-goods.4b0a9c8b.svg";